import { render, staticRenderFns } from "./TableHistorico.vue?vue&type=template&id=eafb8634"
import script from "./TableHistorico.vue?vue&type=script&lang=js"
export * from "./TableHistorico.vue?vue&type=script&lang=js"
import style0 from "./TableHistorico.vue?vue&type=style&index=0&id=eafb8634&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports